
(() => {
  'use strict';

  // TecHub - PushOwl iOS Prompt Arabic Localization

  const lang = document.documentElement.lang || '';
  const isArabic =
    /^ar/i.test(lang) ||
    /^\/ar(?:\/|$)/i.test(window.location.pathname);

  if (!isArabic) return;

  const AR_TITLE = 'خلي TecHub على شاشتك الرئيسية';
  const AR_PREFIX = 'ضيف TecHub للشاشة الرئيسية!';

  const rules = [
    {
      pattern: /Make\s+TecHub\s+Your\s+Go-To\s+Store/gi,
      replacement: AR_TITLE
    },
    {
      pattern: /Add\s+TecHub\s+to\s+your\s+Home\s+Screen!\s*Tap\s+the/gi,
      replacement: 'ضيف TecHub للشاشة الرئيسية! اضغط على أيقونة '
    },
    {
      pattern: /icon\s+and\s+select\s+['’]Add to Home Screen['’]\s+to\s+stay\s+updated\s+with\s+our\s+latest\s+offers\.?/gi,
      replacement: ' واختر «إضافة إلى الشاشة الرئيسية» لمتابعة أحدث عروضنا.'
    }
  ];

  const observed = new WeakSet();

  function setRTL(node) {
    const element = node.parentElement;
    if (!element) return;

    element.setAttribute('dir', 'rtl');
    element.style.direction = 'rtl';
  }

  function belongsToIOSPrompt(node) {
    let element = node.parentElement;

    for (let i = 0; element && i < 12; i++) {
      const content = element.textContent || '';

      if (
        content.includes(AR_TITLE) &&
        content.includes(AR_PREFIX)
      ) {
        return true;
      }

      element = element.parentElement;
    }

    return false;
  }

  function scan(root) {
    if (!root) return;

    const doc = root.nodeType === 9
      ? root
      : root.ownerDocument || document;

    const walker = doc.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT
    );

    let node;

    while ((node = walker.nextNode())) {
      let value = node.nodeValue || '';
      const original = value;

      rules.forEach((rule) => {
        value = value.replace(
          rule.pattern,
          rule.replacement
        );
      });

      if (
        value.trim() === 'Got It' &&
        belongsToIOSPrompt(node)
      ) {
        value = value.replace('Got It', 'تمام');
      }

      if (value !== original) {
        node.nodeValue = value;
        setRTL(node);
      }
    }
  }

  function discover(root) {
    if (!root || !root.querySelectorAll) return;

    root.querySelectorAll('*').forEach((element) => {
      // Accessible open Shadow DOM
      if (element.shadowRoot) {
        observe(element.shadowRoot);
      }

      // Same-origin iframes only
      if (element.tagName === 'IFRAME') {
        const inspect = () => {
          try {
            if (element.contentDocument) {
              observe(element.contentDocument);
            }
          } catch (_) {
            // Cross-origin iframe: inaccessible
          }
        };

        if (!element.dataset.techubLocaleObserved) {
          element.dataset.techubLocaleObserved = '1';
          element.addEventListener('load', inspect);
        }

        inspect();
      }
    });
  }

  function observe(root) {
    if (!root || observed.has(root)) return;

    observed.add(root);

    scan(root);
    discover(root);

    const observer = new MutationObserver(() => {
      scan(root);
      discover(root);
    });

    observer.observe(root, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  observe(document);

})();
